export const extractPlaceholder = (html: string, id: string): string | null => {
	const startMarker = `<input type="hidden" data-lazy-begin="${id}"`;
	const endMarker = `<input type="hidden" data-lazy-end="${id}"`;

	const startIdx = html.indexOf(startMarker);
	if (startIdx === -1) {
		return null;
	}

	const endIdx = html.indexOf(endMarker, startIdx);
	if (endIdx === -1) {
		return null;
	}

	// Find the actual closing tag of the end marker
	const endCloseIdx = html.indexOf('>', endIdx);
	if (endCloseIdx === -1) {
		return null;
	}

	// Extract content between the two markers (excluding the markers themselves)
	const contentStart = html.indexOf('>', startIdx) + 1;
	const contentEnd = endIdx;

	return html.slice(contentStart, contentEnd).trim();
};
export const getPlaceholderHTML = (lazyStartElement: HTMLElement, id: string): string | null => {
	const html = (lazyStartElement.parentNode as HTMLElement)?.innerHTML;
	if (!html) {
		return null;
	}

	return extractPlaceholder(html, id);
};
